export enum AOAlgorithm {
  SAO = 0,
  GTAO = 1,
  NONE = 2,
}
